<template>
  <div class="loginpage">
    <div class="loginbox">
      <div class="l-left">
        <div>
          云南省建设工程<br />
          材料及设备 <br />
          信息登记
        </div>
      </div>
      <div class="l-right">
        <div class="tabs">微信二维码登录</div>
        <div class="l-inputs">
          <img :src="qrcode" class="codebox" />
          <div class="codetip">请使用微信扫描二维码登录“材讯网”</div>
          <p class="codedo mt-40">
            <span
              @click="
                $router.push({
                  path: '/login/resetpwd'
                })
              "
              >忘记密码</span
            >
            <span @click="register">注册账号</span>
          </p>
        </div>
        <div class="other mt-20">
          <div class="back" @click="login">&#60;&nbsp;账号登录</div>
        </div>
        <div class="codelogin" @click="login">
          <i class="iconfont">&#xe608;</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../plugins/axios.js";
export default {
  data() {
    return {
      qrcode: null,
      state: null,
      th: null // 定时器
    };
  },
  mounted() {
    this.getForQrCode();
  },
  beforeDestroy() {
    clearInterval(this.th);
  },
  methods: {
    // 获得登录二维码
    async getForQrCode() {
      const re = await Api.getForQrCode();
      console.log("登录二维码信息", re.qrcode);
      this.qrcode = re.qrcode;
      this.state = re.state;
      const that = this;
      this.th = setInterval(async function() {
        const re = await Api.loginForState(that.state);
        // state是空的时候是登录成功
        if (re.state === "") {
          localStorage.setItem("userinfo", JSON.stringify(re.userinfo));
          that.$store.commit("SET_USERINFO", re.userinfo);
          localStorage.setItem("userid", re.userinfo.id);
          that.$store.commit("SET_USERID", re.userinfo.id);
          localStorage.setItem("token", re.userinfo.token);
          that.$store.commit("SET_TOKEN", re.userinfo.token);
          clearInterval(that.th);
          that.$router.push("/");
        } else {
          clearInterval(that.th);
          that.$store.commit("setWechatLoginState", re.state);
          that.$msgbox({
            title: "提示",
            message: "当前微信未绑定账号，登录后自动绑定",
            type: "warning"
          });
          that.$router.push("/login");
        }
        console.log(re);
      }, 1000);
    },
    login() {
      this.$router.push("/login");
    },
    register() {
      this.$router.push("/login/regis");
    },
    geturl() {}
  },
  head() {
    return {
      title: this.seo_title,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: this.seo_keywords
        },
        {
          hid: "description",
          name: "description",
          content: this.seo_desc
        }
      ]
    };
  }
};
</script>
<style lang="stylus" scoped>
// 下面是公共样式搬迁过来的代码
input {
  border: none;
  /* outline: none; */
  padding: 0 10px;
  box-sizing: border-box;
}
.sendbtn, .sendbtn2 {
  width: 90px;
  height: 50px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 50px;
  text-align: center;
  background: #0082a4;
  color: #fff;
  cursor: pointer;
}
.ml-10 {
  margin-left: 10px;
}

.ml-20 {
  margin-left: 20px;
}

.ml-40 {
  margin-left: 40px;
}

.ml-60 {
  margin-left: 60px;
}

.ml-80 {
  margin-left: 80px;
}

.mr-20 {
  margin-right: 20px;
}

.mr-40 {
  margin-right: 40px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-50 {
  margin-bottom: 50px;
}
// 上面是公共样式搬迁过来的代码
.loginpage
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 100%
  height calc(100vh - 150px)
  min-height calc(100vh - 150px)
.loginbox
  display flex
  justify-content center
  width 640px
  box-shadow 0px 0px 12px rgba(0,0,0,0.15)
  background #fff
.l-left
  text-align center;
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 280px
  border-radius 4px 0 0 4px
  background url(../../assets/coverBg.png) no-repeat
  background-size cover
  background-position 76% 0%
  font-size:24px;
  font-weight:600;
  line-height:40px;
  color:rgba(255,255,255,1);
  opacity:1;
  p
    margin-top 16px
.l-right
  position relative
  width 450px
  padding 26px 40px
  box-sizing borer-box
  border-radius 0 4px 4px 0
  font-size 14px
  color #222328
.codelogin
  position absolute
  top 10px
  right 10px
  i
    font-size 55px
    color #0082a4
    cursor pointer
.tabs
  padding 10px 0
  border-bottom 1px #e6e6e6 solid
  box-sizing border-box
  font-size 18px
.l-inputs
  min-height 330px
  display flex
  flex-direction column
  align-items center
  justify-content center
.codebox
  width 200px
  height 200px
  padding 5px
  border 1px #ddd dashed
  box-sizing border-box
.codetip
  margin-top 4px
  font-size 12px
.codedo
  line-height 14px
  color #999
  span
    padding 0 10px
    border-right 1px #999 solid
    box-sizing border-box
    cursor pointer
  span:hover
    color #0082a4
  span:last-child
    border none
.other
  display flex
  align-items center
  justify-content space-between
  .back
    color #666666
    cursor pointer
  .back:hover
    color #0082a4
.sendbtn, .sendbtn2
  height 40px
  line-height: 40px;
</style>
